import React from "react"
import { StaticQuery, graphql } from 'gatsby'

import { replaceNewlineCharacters } from '../../utils/replaceNewlineCharacters'

import "./home.scss"
import {replaceMarkdown} from "../../utils/replaceMarkdown";

const Home = () => (
    <StaticQuery
        query={graphql`
        {
          cmsData {
            eventDetailses(first: 1) {
              id
              date
              location
              hostFederation {
                url
              }
              map
            }
            pageDescriptions(where:{page:Home }) {
              description 
            }
          }
        }
  `}
        render={data => (
          <div>
            <h1 className="header">Event details</h1>

            <p className="description" dangerouslySetInnerHTML={{
              __html: replaceMarkdown(data.cmsData.pageDescriptions[0].description)
            }} />

            <div className="details">
              <div>
                <h1>Date</h1>
                <div dangerouslySetInnerHTML={{
                  __html: replaceNewlineCharacters(data.cmsData.eventDetailses[0].date)
                }} />
              </div>
              <div>
                <h1>Location</h1>
                <div dangerouslySetInnerHTML={{
                  __html: replaceNewlineCharacters(data.cmsData.eventDetailses[0].location)
                }} />
              </div>
              <div>
                <h1>Host Federation</h1>
                <div>
                    <img id="host" alt="" src={data.cmsData.eventDetailses[0].hostFederation.url} />
                </div>
              </div>
            </div>
            <div id="map">
              <iframe src={data.cmsData.eventDetailses[0].map} frameBorder="0"
                      allowFullScreen title="map"/>
            </div>
          </div>
        )}
    />

)

export default Home
